"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDetailsDocumentVerdict = void 0;
/**
 * The document verification verdict saved on the property details attestation report; underwriting reads it.
 * @TranslateToPython @TranslateToEnum
 */
var PropertyDetailsDocumentVerdict;
(function (PropertyDetailsDocumentVerdict) {
    PropertyDetailsDocumentVerdict["match"] = "match";
    PropertyDetailsDocumentVerdict["mismatch"] = "mismatch";
    PropertyDetailsDocumentVerdict["inconclusive"] = "inconclusive";
})(PropertyDetailsDocumentVerdict || (exports.PropertyDetailsDocumentVerdict = PropertyDetailsDocumentVerdict = {}));
